import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/eap/settings")({
  component: lazyRouteComponent(() => import("./+Eap")),
  head: () => ({ meta: seo({ title: "EAP Settings" }) }),
});
